import { APP_IDS } from "../shared/appIds";

export const PLANY_CARE_APP = Object.freeze({
  id: APP_IDS.PLANY_CARE,
  brandName: "Plany365 Care",
  shortBrandName: "Plany365",
  brandLabel: "Care",
  verticalId: "care",
  hosts: Object.freeze([
    "care.plany365.com",
    "plany365.com",
    "www.plany365.com",
    "providers.plany365.com",
  ]),
  publicHost: "care.plany365.com",
  publicHomePath: "/care",
  businessHomePath: "/biz/dashboard?v=care",
  ownsRoutePrefixes: Object.freeze([
    "/care",
    "/find",
    "/referrer",
    "/referrals",
    "/resident-management",
    "/emar",
    "/jobs",
    "/marketplace",
    "/biz/dashboard",
    "/biz/resident",
    "/biz/manage/jobs",
    "/biz/marketplace",
  ]),
  features: Object.freeze({
    planyAssistant: true,
    productSwitcher: false,
    bookingProviderSettings: true,
  }),
});
